import Vue from 'vue';

export default {
	TOGGLE_SHOW_ANSWER(state) {
		state.showAnswer = !state.showAnswer;
	},
	SET_EXAM(state, { bankExam = {}, roomExam = {}, roomExamInfo = {} } = {}) {
		state.bankExam = bankExam;
		state.roomExam = roomExam;
		state.roomExamInfo = roomExamInfo;
	},
	SET_USER(state, { roomExamUser }) {
		const user = state.roomExamUsersAnswerObj[roomExamUser.userId];
		if (!user) {
			Vue.set(state.roomExamUsersAnswerObj, roomExamUser.userId, {
				username: roomExamUser.username,
				completed: false,
			});
		}
	},
	SET_USER_ANSWER_LIST(state, userAnswerList) {
		const createUserQuestionList = (userId, userQuestion) => {
			const userQuestionList = state.roomExamUsersAnswerObj[userId]?.userQuestionList;
			if (!userQuestionList) {
				return [ userQuestion ];
			}

			let roomUserQuestion = userQuestionList.find((uq) => uq.questionId === userQuestion.questionId);
			if (roomUserQuestion) {
				roomUserQuestion.userAnswerList = userQuestion.userAnswerList;
			} else {
				userQuestionList.push(userQuestion);
			}

			return userQuestionList;
		}

		const setRoomExamUsersAnswerList = ({ roomExamUser, userQuestion }) => {
			if (!roomExamUser.userQuestionList && !userQuestion) {
				Vue.set(state.roomExamUsersAnswerObj, roomExamUser.userId, {
					userQuestionList: [],
					username: roomExamUser.username,
					completed: false,
				});
				return;
			}

			Vue.set(state.roomExamUsersAnswerObj, roomExamUser.userId, {
				userQuestionList: roomExamUser.userQuestionList || createUserQuestionList(roomExamUser.userId, userQuestion.userQuestion || userQuestion),
				username: roomExamUser.username,
				completed: !state.isLoadedExam && !!roomExamUser.endDate,
			})
		}

		if (Array.isArray(userAnswerList)) {
			userAnswerList.forEach((userAnswer) => setRoomExamUsersAnswerList(userAnswer));
			return;
		}

		setRoomExamUsersAnswerList(userAnswerList);

		if (!state.isLoadedExam) {
			state.isLoadedExam = true;
		}
	},
	CLEAR_USER_ANSWER_LIST(state) {
		state.roomExamUsersAnswerObj = {};
	},
	COMPLETE_USER(state, {
		roomExamUser
	} = {
		roomExamUser: this.getters['user/me']
	}) {
		const user = state.roomExamUsersAnswerObj[roomExamUser.userId];
		if (user) {
			user.completed = true;
		}
	},
	EDIT_EXAM(state) {
		const me = this.getters['user/me'];
		if (!me) {
			return;
		}

		const user = state.roomExamUsersAnswerObj[me.userId];
		if (!user) {
			return;
		}

		user.completed = false;
	}
}
